import { render, staticRenderFns } from "./AdministrarArtistas.vue?vue&type=template&id=6bbf5dc9&scoped=true&"
import script from "./AdministrarArtistas.vue?vue&type=script&lang=js&"
export * from "./AdministrarArtistas.vue?vue&type=script&lang=js&"
import style0 from "./AdministrarArtistas.vue?vue&type=style&index=0&id=6bbf5dc9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bbf5dc9",
  null
  
)

export default component.exports